module.exports = {
  sockets: require('./sockets'),
};
